import axios from '__js__/axios';
import reverse from 'django-reverse';

export const switchLanguage = async (url, payload) =>
	await axios.post(url || reverse('set_language'), payload);
